import './CustomDataLocation.scss';

import { mdiMapMarker } from '@mdi/js';
import type { GeoCoordinate } from 'common/models';
import Button from 'components/Button/Button';
import { FakeLabel } from 'components/forms';
import Icon from 'components/Icon/Icon';
import MapContainer from 'components/MapContainer/MapContainer';
import Modal from 'components/Modal/Modal';
import React, { useState } from 'react';

interface Props {
  label?: string;
  location?: GeoCoordinate;
}

const CustomDataGeoCoordinate: React.FC<Props> = (props): React.ReactElement => {
  const { label, location } = props;

  const [showMap, setShowMap] = useState(false);

  return (
    <div className="CustomDataLocation">
      <FakeLabel>{label}</FakeLabel>
      {location && (
        <div className="CustomDataLocation_content">
          <div>{`${location.latitude}, ${location.longitude}`}</div>
          <Button
            icon={<Icon path={mdiMapMarker} onClick={() => setShowMap(true)} />}
            className="CustomDataLocation_mapButton"
          />
        </div>
      )}
      <Modal open={showMap} onClose={() => setShowMap(false)}>
        <div style={{ height: '400px' }}>
          <MapContainer
            clickableMarker={false}
            latitude={location?.latitude}
            longitude={location?.longitude}
          />
        </div>
      </Modal>
    </div>
  );
};

export default CustomDataGeoCoordinate;
